export default function SectionHeading({ eyebrow, title, description, align = "left" }) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignment}`}>
      {eyebrow && (
        <div className="flex items-center gap-3 mb-4 justify-start">
          <span className="accent-line" />
          <span className="text-xs uppercase tracking-[0.25em] text-[#D97706] font-medium">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#0F5132] leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base md:text-lg text-[#4B5563] leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
